import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/NotifyRight/Get`, payload),
    Edit: (payload) => Repository.post(`/api/NotifyRight/Edit`, payload),
}
